import { IResponse } from "./helper.interface";
import { IQuestion } from "./question.interface";

interface IUnderwritingAnswer {
  hidden: boolean;
  max: number;
  min: number;
  object_field: string;
  object_name: string;
  place_holder: string;
  required: boolean;
}

export interface IUnderwritingQuestion {
  heading: string;
  order: number;
  options?: Array<string>;
  portal_filter_category: string;
  sub_heading: string;
  type: string;
  question_type?: string;
  underwriting_answers: Array<IUnderwritingAnswer>;
  wording: string;
  wording_for_summary: string;
}

interface UIUnderwritingQuestionResult {
  all_risks?: Array<IUnderwritingQuestion>;
  buildings?: Array<IUnderwritingQuestion>;
  caravans?: Array<IUnderwritingQuestion>;
  contents?: Array<IUnderwritingQuestion>;
  motorcycles?: Array<IUnderwritingQuestion>;
  personal_details?: Array<IUnderwritingQuestion>;
  insurance_history?: Array<IUnderwritingQuestion>;
  specified_items?: Array<IUnderwritingQuestion>;
  vehicles?: Array<IUnderwritingQuestion>;
}

export interface IUnderwritingQuestions extends IResponse {
  results: UIUnderwritingQuestionResult;
}

export interface IProgressChecker {
  progress?: IProgress;
  questions?: Array<IQuestion>;
}

interface IProgress {
  progress: number;
  total_questions: number,
  valid_questions: number,
}
